import * as React from 'react'

import Svg, { ClipPath, Defs, G, Path } from 'react-native-svg'

const NetworkIssue = (props) => (
  <Svg
    width={152}
    height={151}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <Path
      d="M61.815 15.829c-5.686 5.417-10.47 13.991-13.797 24.585a61.733 61.733 0 0 1-13.83-9.742c7.648-7.14 17.116-12.344 27.627-14.843ZM30.856 34.053a66.275 66.275 0 0 0 15.836 10.985c-2.204 8.46-3.516 17.99-3.695 28.105H14.715c.574-15.048 6.6-28.706 16.14-39.09ZM14.715 77.86h28.282c.177 10.112 1.491 19.644 3.695 28.104a66.256 66.256 0 0 0-15.836 10.986c-9.542-10.386-15.567-24.045-16.14-39.09ZM73.64 73.14H47.717c.167-9.68 1.356-18.476 3.275-26.148a65.653 65.653 0 0 0 22.65 4.855v21.294ZM73.64 47.13a60.83 60.83 0 0 1-21.378-4.744c4.927-16.09 13.166-26.312 21.379-27.977V47.13ZM78.36 14.406c8.215 1.666 16.454 11.887 21.378 27.978a60.839 60.839 0 0 1-21.379 4.745V14.406ZM78.36 51.85a65.702 65.702 0 0 0 22.649-4.856c1.919 7.673 3.108 16.468 3.275 26.149H78.359V51.85ZM121.144 116.947a66.268 66.268 0 0 0-15.836-10.985c2.204-8.46 3.516-17.99 3.695-28.105h28.282c-.574 15.048-6.599 28.707-16.141 39.09ZM101.269 19.632a60.95 60.95 0 0 0-11.084-3.803c3.55 3.383 6.75 7.998 9.463 13.566-.016-.36-.054-.717-.054-1.082 0-3.068.606-5.991 1.675-8.68ZM106.143 44.583c-.283.146-.552.311-.835.453 2.204 8.46 3.516 17.99 3.695 28.105h28.282c-.309-8.145-2.258-15.86-5.453-22.898a23.41 23.41 0 0 1-8.644 1.663c-6.701 0-12.746-2.822-17.045-7.323Z"
      fill="#D1D9E9"
    />
    <Path
      d="M123.188 47.188c10.424 0 18.874-8.451 18.874-18.876 0-10.424-8.45-18.875-18.874-18.875-10.425 0-18.876 8.451-18.876 18.876 0 10.424 8.451 18.875 18.876 18.875Z"
      fill="#FA6450"
    />
    <Path
      d="M108.991 28.313c0-9.631 7.217-17.561 16.537-18.715a18.713 18.713 0 0 0-2.34-.16c-10.424 0-18.876 8.45-18.876 18.874s8.452 18.875 18.876 18.875c.792 0 1.571-.063 2.338-.16-9.318-1.154-16.535-9.084-16.535-18.715Z"
      fill="#DC4632"
    />
    <G clipPath="url(#a)">
      <Path
        d="M115.605 28.735a2.792 2.792 0 0 0 0 3.962 2.826 2.826 0 0 0 3.982 0 4.916 4.916 0 0 1 6.928 0 2.825 2.825 0 0 0 3.981 0 2.79 2.79 0 0 0 0-3.962c-4.112-4.092-10.779-4.092-14.891 0Z"
        fill="#FAFBFE"
      />
      <Path
        d="M135.951 23.307c-7.125-7.09-18.676-7.09-25.8 0a2.79 2.79 0 0 0 0 3.962 2.825 2.825 0 0 0 3.981 0c4.926-4.901 12.912-4.901 17.837 0a2.826 2.826 0 0 0 3.982 0 2.792 2.792 0 0 0 0-3.962ZM125.038 38.123a2.792 2.792 0 0 0 0-3.96 2.825 2.825 0 0 0-3.981 0 2.792 2.792 0 0 0 0 3.96 2.825 2.825 0 0 0 3.981 0Z"
        fill="#FAFBFE"
      />
      <Path
        d="M130.496 32.697a2.79 2.79 0 0 0 0-3.962 10.522 10.522 0 0 0-7.445-3.069v5.603c1.254 0 2.507.476 3.464 1.428a2.825 2.825 0 0 0 3.981 0ZM135.951 27.269a2.792 2.792 0 0 0 0-3.962 18.232 18.232 0 0 0-12.9-5.317v5.603c3.228 0 6.456 1.225 8.919 3.676a2.825 2.825 0 0 0 3.981 0ZM125.866 36.143a2.808 2.808 0 0 0-2.815-2.801v5.603a2.808 2.808 0 0 0 2.815-2.802Z"
        fill="#D1D9E9"
      />
    </G>
    <Path
      d="M48.018 110.586a61.734 61.734 0 0 0-13.83 9.742c2.302 2.149 4.803 4.079 7.417 5.854l7.366-12.89c-.32-.898-.66-1.769-.953-2.706ZM69.854 77.86H47.718c.168 9.68 1.357 18.476 3.275 26.148a56.022 56.022 0 0 1 4.143-1.503L67.808 80.33a9.483 9.483 0 0 1 2.046-2.47ZM84.194 80.33l12.672 22.175c1.404.451 2.79.949 4.143 1.503 1.919-7.672 3.108-16.468 3.275-26.149H82.148a9.577 9.577 0 0 1 2.046 2.47ZM117.813 120.328a61.744 61.744 0 0 0-13.831-9.742c-.295.937-.632 1.808-.953 2.706l7.366 12.89c2.614-1.775 5.115-3.705 7.418-5.854Z"
      fill="#D1D9E9"
    />
    <Path
      d="m71.904 82.67-29.62 51.833c-1.797 3.145.475 7.059 4.096 7.059h59.237c3.624 0 5.894-3.914 4.096-7.059L80.096 82.67c-1.81-3.17-6.382-3.17-8.192 0Z"
      fill="#FAB400"
    />
    <Path
      d="m48.315 134.503 29.62-51.833c.29-.51.67-.906 1.08-1.253-2.144-1.805-5.591-1.408-7.113 1.253l-29.617 51.833c-1.798 3.145.474 7.059 4.095 7.059h6.033c-3.624 0-5.893-3.914-4.098-7.059Z"
      fill="#DC9600"
    />
    <Path
      d="M34.187 30.672c1.65 1.54 3.407 2.963 5.217 4.315a61.548 61.548 0 0 1 17.971-14.015c1.409-1.927 2.886-3.664 4.44-5.143-10.51 2.499-19.979 7.703-27.628 14.843ZM24.15 73.14a60.982 60.982 0 0 1 12.262-34.486c-1.928-1.444-3.8-2.959-5.556-4.604-8.343 9.08-13.996 20.664-15.669 33.487l-.007.06a61.234 61.234 0 0 0-.465 5.541l9.435.003ZM36.412 112.346A60.991 60.991 0 0 1 24.15 77.859h-9.435c.071 1.871.23 3.719.465 5.543l.007.058c1.673 12.824 7.326 24.408 15.669 33.487 1.755-1.644 3.628-3.157 5.556-4.601ZM41.6 126.177l.005.002 2.897-5.072c-1.79-1.607-3.508-3.292-5.098-5.097a72.613 72.613 0 0 0-2.584 2.022 62.73 62.73 0 0 0-2.633 2.296 59.227 59.227 0 0 0 3.631 3.096c1.227.96 2.49 1.878 3.782 2.753Z"
      fill="#8691A8"
    />
    <Path
      d="M72 103.719v14.156a4.718 4.718 0 0 0 4.719 4.719 4.718 4.718 0 0 0 4.719-4.719v-14.156A4.718 4.718 0 0 0 76.718 99 4.718 4.718 0 0 0 72 103.719ZM72 130.031a4.718 4.718 0 0 0 4.719 4.719 4.718 4.718 0 0 0 4.719-4.719 4.718 4.718 0 0 0-4.72-4.719A4.718 4.718 0 0 0 72 130.031Z"
      fill="#505050"
    />
    <Defs>
      <ClipPath id="a">
        <Path
          fill="#fff"
          transform="translate(109.326 17.99)"
          d="M0 0h27.428v20.939H0z"
        />
      </ClipPath>
    </Defs>
  </Svg>
)

export default NetworkIssue
